import { Controller } from 'stimulus';

export default class UserMenuController extends Controller {
  static targets = [ 'menu', 'toggler' ]

  connect() {
    document.addEventListener('click', (event) => {
      if (this.element.contains(event.target) === false && this.menuTarget.classList.contains('is-visible')) {
        this.closeAllMenus(event)
      }
    })

    document.addEventListener('keydown', (event) => {
      if ( event.which === 27 && this.menuTarget.classList.contains('is-visible') ) {
        this.closeAllMenus(event)
      }
    })
  }

  toggleMenu(event) {
    event.preventDefault();

    this.menuTarget.classList.toggle('is-visible');
    event.currentTarget.classList.toggle('menu-visible');
  }

  closeAllMenus() {
    this.menuTarget.classList.remove('is-visible');
    this.togglerTarget.classList.remove('menu-visible');
  }
}
